import React, { Component, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import "src/assets/css/fullapp.css";
import { ToastNotificationContainer } from 'src/animation/notificationUtils';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import { Provider } from 'react-redux';

import 'react-toastify/dist/ReactToastify.css';
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layouts/DefaultLayout'))
const Login = React.lazy(() => import('./layouts/Login'))
const Entity = React.lazy(() => import('./layouts/Entity'))

// Pages
// const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const SecureAccess = React.lazy(() => import('./views/pages/SecureAccess/SecureAccess'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const Page503 = React.lazy(() => import('./views/pages/page503/page503'))

class App extends Component {



  render() {
    return (
      <PersistGate loading={null} persistor={persistor}>
        <Provider store={store}>
          <BrowserRouter>
            <Suspense fallback={loading}>
              <Routes>
                <Route exact path="/login" name="Login Page" element={<Login />} />
                <Route exact path="/enter-your-company-entity" name="Entity Page" element={<Entity />} />
                <Route exact path="/register" name="Register Page" element={<Register />} />
                <Route exact path="/404" name="Page 404" element={<Page404 />} />
                <Route exact path="/secure_access/opti-light" name="Secure access" element={<SecureAccess />} />
                <Route exact path="/secure_access/opti-light-local" name="Secure access" element={<SecureAccess />} />
                <Route exact path="/500" name="Page 500" element={<Page500 />} />
                <Route exact path="/503" name="Page 503" element={<Page503 />} />
                <Route exact path="/home" name="Home" element={<DefaultLayout />} />
                <Route path="/" name="Login" element={<Login />} />
                <Route path="*" name="Home" element={<DefaultLayout />} />
              </Routes>
            </Suspense>
            <ToastNotificationContainer />
          </BrowserRouter>
        </Provider>
      </PersistGate>
    )
  }
}

export default App
